import axios from '@/http/axios';

export default {
  fetchList: (config: any = {}) => {
    return axios.get(`/candidate-profiles/list`, config);
  },
  fetchForUpdate: (config: any = {}) => {
    return axios.get(`/candidate-profiles`, config);
  },
  fetchNextQuestion: (objectId, config: any = {}) => {
    const cpModel = objectId ? `/${objectId}/` : '/';
    return axios.get(`/candidate-profiles${cpModel}next`, config);
  },
  fetchPreviousQuestion: (objectId, config: any = {}) => {
    const cpModel = objectId ? `/${objectId}/` : '/';
    return axios.get(`/candidate-profiles${cpModel}previous`, config);
  },
  updateAnswer: (objectId, config: any = {}) => {
    const cpModel = objectId ? `/${objectId}/` : '/';
    return axios.put(`/candidate-profiles${cpModel}update`, config);
  },
  fetchForRead: (objectId, config: any = {}) => {
    const cpModel = objectId ? `/${objectId}/` : '/';
    return axios.get(`/candidate-profiles${cpModel}read`, config);
  },
  fetchForPreview: (objectId, config: any = {}) => {
    return axios.get(`/candidate-profiles/${objectId}/preview`, config);
  },
  complete: (config: any = {}) => {
    return axios.put(`/candidate-profiles/complete`, config);
  },
  fetchByCandidate: (config: any = {}) => {
    return axios.get(`/candidate-profiles/fetch-by-candidate`, config);
  },
  candidateProfileKeyCheck: (config) => {
    return axios.get(
      `/candidate-profiles/candidate-profile-question-key-check`,
      config
    );
  },
  fetchCandidateProfileItems: (config: any = {}) => {
    return axios.get(`/candidate-profiles/candidate-profile-items`, config);
  },
  createForPreview: (config: any = {}) => {
    return axios.post(`/candidate-profiles/preview`, config);
  },
  updateForPreview: (objectId, config: any = {}) => {
    return axios.put(`/candidate-profiles/preview/${objectId}`, config);
  },
};
